import styled from 'styled-components'
import WordItem from './WordItem'

const Container = styled.div`
  margin-top: 10px;
  height: auto;
  hr{
    border: 1px solid ${(props) => props.theme.colors.neutral[300]};
  }
`
const WordList = ({list, onToggle, onItemClick }) => {
  return (
    <Container>
      <ul>
        {list.map((item, index) => (
          <li key={item.id}>
            <WordItem 
              item={item} 
              onToggle={onToggle}
              onClickItem={() => onItemClick(item.id)}/>
            {index !== list.length - 1 && <hr />}
          </li>
        ))}
      </ul>
    </Container>
  )
}

export default WordList
